import { render, staticRenderFns } from "./VideoPlugin.vue?vue&type=template&id=088bca3d&scoped=true&"
import script from "./VideoPlugin.vue?vue&type=script&lang=js&"
export * from "./VideoPlugin.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlugin.vue?vue&type=style&index=0&id=088bca3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088bca3d",
  null
  
)

export default component.exports